var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlignCenterHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.875C12.3452 3.875 12.625 4.15482 12.625 4.5V6.375C12.625 6.72018 12.3452 7 12 7C11.6548 7 11.375 6.72018 11.375 6.375V4.5C11.375 4.15482 11.6548 3.875 12 3.875Z",
    fill: "#1A181E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 17C12.3452 17 12.625 17.2798 12.625 17.625V19.5C12.625 19.8452 12.3452 20.125 12 20.125C11.6548 20.125 11.375 19.8452 11.375 19.5V17.625C11.375 17.2798 11.6548 17 12 17Z",
    fill: "#1A181E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10.125C12.3452 10.125 12.625 10.4048 12.625 10.75V13.25C12.625 13.5952 12.3452 13.875 12 13.875C11.6548 13.875 11.375 13.5952 11.375 13.25V10.75C11.375 10.4048 11.6548 10.125 12 10.125Z",
    fill: "#1A181E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.375 7C6.375 6.30964 6.93464 5.75 7.625 5.75H16.375C17.0654 5.75 17.625 6.30964 17.625 7V10.125C17.625 10.8154 17.0654 11.375 16.375 11.375H7.625C6.93464 11.375 6.375 10.8154 6.375 10.125V7ZM16.375 7H7.625V10.125H16.375V7Z",
    fill: "#1A181E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 13.875C4.5 13.1846 5.05964 12.625 5.75 12.625H18.25C18.9404 12.625 19.5 13.1846 19.5 13.875V17C19.5 17.6904 18.9404 18.25 18.25 18.25H5.75C5.05964 18.25 4.5 17.6904 4.5 17V13.875ZM18.25 13.875H5.75V17H18.25V13.875Z",
    fill: "#1A181E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignCenterHorizontal);
export default __webpack_public_path__ + "static/media/align-center-horizontal.546dc21a265c222455d91be0dfa017ad.svg";
export { ForwardRef as ReactComponent };